export default __webpack_public_path__ + "static/20_36-03add2d008a15dfbdcd55fc4d6d80e0c.png";